<template>
  <gg-card class="fill-height">
    <gg-card-header>
      Select Period
    </gg-card-header>
    <gg-card-text>
      <v-row>
        <v-col cols="12">
          Select a period for the report view.
          <v-row class="pt-3">
            <v-col cols="11" sm="5">
              <v-menu
                v-if="period === 'monthly'"
                ref="menu"
                v-model="menu"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <div>
                    <gg-input-label>Reporting Period</gg-input-label>
                    <v-text-field
                      dense
                      outlined
                      autocomplete="off"
                      :value="formattedDate"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    />
                  </div>
                </template>
                <v-date-picker
                  v-model="date"
                  type="month"
                  min="2009-01-01"
                  no-title
                  scrollable
                  :max="currentDate"
                >
                </v-date-picker>
              </v-menu>
              <gg-select
                v-else
                label="Reporting Period"
                v-model="date"
                :items="years"
              />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </gg-card-text>
  </gg-card>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import format from 'date-fns/format'
import parse from 'date-fns/parse'

export default {
  name: 'ReportingPeriod',
  props: {
    period: {
      type: String,
      required: true,
      validator (val) {
        return ['monthly', 'yearly'].includes(val)
      }
    }
  },
  data: () => ({
    menu: false,
    modal: false,
    years: []
  }),
  computed: {
    ...mapGetters({
      reportingDate: 'affiliates/reportingDate'
    }),
    isYearly () {
      return this.period === 'yearly'
    },
    date: {
      set (val) {
        let date = val
        if (this.isYearly) {
          const month = format(new Date(), 'MM')
          date = `${val}-${month}`
        }
        this.setDate(date)
        switch (this.period) {
          case 'monthly':
            this.getMonthlyStatistics(true)
            break
          case 'yearly':
            this.getYearlyStatistics(true)
            break
          default:
            this.getMonthlyStatistics(true)
        }
      },
      get () {
        if (this.isYearly) {
          return format(new Date(this.reportingDate), 'yyyy')
        }
        return this.reportingDate
      }
    },
    formattedDate () {
      const newDate = parse(this.reportingDate, 'yyyy-MM', new Date())
      const formatted = format(newDate, 'MMMM yyyy')
      return formatted
    },
    currentDate () {
      const currentDate = new Date()
      const currentYear = currentDate.getFullYear()
      const currentMonth = String(currentDate.getMonth() + 1).padStart(2, '0')
      return `${currentYear}-${currentMonth}`
    }
  },
  methods: {
    ...mapMutations({
      setDate: 'affiliates/SET_REPORTING_DATE'
    }),
    ...mapActions({
      getMonthlyStatistics: 'affiliates/getMonthlyStatistics',
      getYearlyStatistics: 'affiliates/getYearlyStatistics',
    }),
  },
  mounted () {
    const currentYear = format(new Date(), 'yyyy')
    for (let i = 0; i <= 10; i++) {
      this.years.push(currentYear - i + '') // as string
    }
  }
}
</script>

<style scoped>

</style>
